var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOopsytelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_127)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 0H0V90H90V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9496 89.4048C69.5014 89.4048 89.4047 69.5015 89.4047 44.9497C89.4047 20.3978 69.5014 0.494629 44.9496 0.494629C20.3977 0.494629 0.494507 20.3978 0.494507 44.9497C0.494507 69.5015 20.3977 89.4048 44.9496 89.4048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7994 65.3249C35.3591 65.3249 35.6042 64.7816 35.1071 63.4093L30.8722 49.4721L63.4724 30.1313",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7994 65.325C37.9109 65.325 38.4019 64.8171 39.0222 64.2135L44.9496 58.4501L37.5561 53.9917",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5552 53.993L55.4706 67.2286C57.5156 68.3568 58.9905 67.7731 59.5001 65.331L66.7928 30.9663C67.5396 27.9729 65.6518 26.6145 63.6957 27.5026L20.8737 44.0142C17.9505 45.1869 17.9683 46.818 20.3412 47.544L31.3305 50.9739L56.7706 34.9238C57.9719 34.1957 59.0744 34.5867 58.1694 35.39L37.5552 53.993Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOopsytelegram);
export default __webpack_public_path__ + "static/media/oopsytelegram.16461473a11ddc580ba45598e2de339b.svg";
export { ForwardRef as ReactComponent };